import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M19.348 7.048h-2.644l-1.487-1.62h-4.956v1.62h4.213l1.57 1.619h3.304v9.714H6.13v-7.286H4.478v7.286c0 .89.744 1.619 1.652 1.619h13.218c.909 0 1.652-.729 1.652-1.619V8.667c0-.89-.744-1.62-1.652-1.62m-10.74 6.476c0 3.602 4.453 5.416 7.056 2.866s.751-6.914-2.925-6.914c-2.28 0-4.13 1.813-4.13 4.048m4.131-2.429c1.355.04 2.437 1.101 2.478 2.429-.04 1.327-1.123 2.388-2.478 2.428-1.355-.04-2.437-1.1-2.478-2.428.041-1.328 1.123-2.388 2.478-2.429M6.13 7.048H8.61v-1.62H6.13V3H4.478v2.429H2v1.619h2.478v2.428H6.13"
    }, null, -1)
  ])))
}
export default { render: render }